import { Fragment, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Scrollbar, Typography } from 'shared/ui'
import { FooterSectionStore } from './store/footerSectionStore'
import styles from './styles.module.scss'

export const FooterSection = observer(() => {
  const store = useMemo(() => new FooterSectionStore(), [])

  return (
    <div className={styles.footerSection}>
      <Scrollbar height={24} viewClassName={styles.scrollView}>
        <div className={styles.linksWrapper}>
          {store.links.map((link, index) => (
            <Fragment key={link.key}>
              <a href={link.url} target='_blank' rel='noopener noreferrer' className={styles.link}>
                <Typography variant='body-sm-regular' ariaLabel={link.key}>
                  {link.label}
                </Typography>
              </a>
              {index < store.links.length - 1 && <span className={styles.separator} />}
            </Fragment>
          ))}
        </div>
      </Scrollbar>
    </div>
  )
})
